module.exports = __webpack_public_path__ + "img/744.01c7b15c.jpg";